<template lang="pug">
  div(@click="clickOutside")
    div.d-flex.justify-center.mt-16(v-if="isFetching")
      v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
    v-container.pt-6(v-else fluid)
      v-form(ref="form")
        div.px-10
          v-row.mb-2(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="goBack" height)
                v-icon(color="neutral700" :size="24") mdi-arrow-left
            v-col.ml-3
              .text-2xl.font-semibold.neutral700--text {{ id ? 'Edit invoice' : 'New invoice' }}
          v-divider
          v-row.mt-2
            v-col(cols="4")
              v-row.py-1(no-gutters)
                v-col(cols="3")
                  .text-sm.font-semibold.neutral500--text.mt-3 Seller
                v-col(cols="9")
                  medication-sold-by-dropdown(v-if="showSellerInput" v-model="seller" attach show-add-seller :error="showSellerError" @closed="showSellerError = false"  @change="showSellerInput = false")
                  div.mt-3(v-else)
                    .text-sm.font-semibold.neutral700--text {{ seller.sold_by }}
                    .text-sm.neutral700--text.mt-1 {{ seller.name }}
                    .text-sm.neutral700--text {{ seller.phone }}
                    y-button(label="Change seller" size="xs" underline button-class="px-0" @click="showSellerInput = true")

            v-col(cols="4")
              v-row(no-gutters align="center" :class="showInvoiceDateInput ? 'py-1' : 'mt-2'")
                v-col(cols="3")
                  div.text-sm.font-semibold.neutral500--text Invoice date
                v-col(cols="9")
                  y-dialog(v-if="showInvoiceDateInput"  v-model="showInvoicePicker" width='320px' persistent)
                    template(v-slot:activator='{ on }')
                      v-text-field.text-sm.round-xl.date-field(v-model="invoiceDateField" placeholder="Invoice date" outlined dense height="48" readonly :rules="rules.not_empty" hide-details="auto" v-on="on" clearable)
                        template(v-slot:append)
                          eva-icon(name="calendar-outline" fill="#848484")
                    v-card
                      v-card-text.px-2.pt-2.pb-0
                        yc-date-picker(:parentDate.sync="invoice.record_date" color="info")
                      v-card-actions.px-4.pb-4
                        v-row(no-gutters)
                          v-col.pr-2
                            v-btn.button-sm(color="basic700" block dark outlined depressed @click="closePicker('showInvoicePicker', 'showInvoiceDateInput', true)") {{ $t('cancel') }}
                          v-col.pl-2
                            v-btn.button-sm(color="info500" block depressed dark @click="pickDate('invoiceDateField', 'showInvoicePicker', invoice.record_date, 'showInvoiceDateInput')") {{ $t('select') }}
                  div.d-flex.align-center(v-else)
                    .text-sm.neutral700--text {{ invoiceDateField }}
                    y-button.ml-1(label="Edit" size="xs" underline button-class="px-0" @click="showInvoiceDateInput = true")
              v-row(no-gutters align="center" :class="{ 'py-1' : showPaymentDueDateInput }")
                v-col(cols="3")
                  div.text-sm.font-semibold.neutral500--text Payment due
                v-col(cols="9")
                  y-dialog(v-if="showPaymentDueDateInput" v-model="showPaymentDuePicker" width='320px' persistent)
                    template(v-slot:activator='{ on }')
                      v-text-field.text-sm.round-xl.date-field(v-model="PaymentDueDateField" placeholder="Payment due" outlined dense height="48" readonly :rules="rules.not_empty" hide-details="auto" v-on="on" clearable)
                        template(v-slot:append)
                          eva-icon(name="calendar-outline" fill="#848484")
                    v-card
                      v-card-text.px-2.pt-2.pb-0
                        yc-date-picker(:parentDate.sync="invoice.due_at" color="info")
                      v-card-actions.px-4.pb-4
                        v-row(no-gutters)
                          v-col.pr-2
                            v-btn.button-sm(color="basic700" block dark outlined depressed @click="closePicker('showPaymentDuePicker', 'showPaymentDueDateInput', false)") {{ $t('cancel') }}
                          v-col.pl-2
                            v-btn.button-sm(color="info500" block depressed dark @click="pickDate('PaymentDueDateField', 'showPaymentDuePicker', invoice.due_at, 'showPaymentDueDateInput')") {{ $t('select') }}
                  div.d-flex.align-center(v-else)
                    .text-sm.neutral700--text {{ PaymentDueDateField }}
                    y-button.ml-1(label="Edit" size="xs" underline button-class="px-0" @click="showPaymentDueDateInput = true")
              v-row(no-gutters align="center" :class="{ 'py-1' : showInvoiceNoInput }")
                v-col(cols="3")
                  div.text-sm.font-semibold.neutral500--text Invoice no.
                v-col(cols="9")
                  v-text-field.text-sm.round-xl(v-if="showInvoiceNoInput" v-model="invoice.invoice_no" placeholder="Invoice number" outlined dense height="48" :rules="rules.not_empty" hide-details="auto" @blur="showInvoiceNoInput = !invoice.invoice_no")
                  div.d-flex.align-center(v-else)
                    .text-sm.neutral700--text {{ invoice.invoice_no }}
                    y-button.ml-1(label="Edit" size="xs" underline button-class="px-0" @click="showInvoiceNoInput = true")

            v-col(cols="4" align="right")
              div.text-sm.font-semibold.neutral500--text Balance due
              div.text-5xl.font-semibold.neutral700--text {{ invoiceTotalRemaining | displayPrice($currency) }}
              div.d-flex.align-center.justify-end.mt-3
                div(v-if="payments.length" id="payment" @click.stop)
                  v-tooltip(v-model="showPaymentRecorded" left attach="#payment" color="white" content-class="black tooltip-left-arrow")
                    template(#activator="{ on, attrs }")
                      y-button.mr-6(:label="payments.length > 1 ? `${payments.length} payments recorded` : '1 payment recorded'" underline size="xs" button-class="px-0" @click="showPaymentRecorded = !showPaymentRecorded")
                    v-card(flat)
                      v-simple-table
                        thead
                          tr
                            th Date
                            th Amount
                            th Method
                            th Attachment
                            th remarks
                        tbody
                          tr(v-for="payment in payments" :key="payment.id")
                            td {{ payment.paid_date | humanizeDate }}
                            td {{ payment.amount | displayPrice($currency) }}
                            td {{ payment.payment_method }}
                            td
                              y-button(v-if="payment.document" label="View" underline size="xs" button-class="px-0" @click="viewPaymentFile(payment)") 
                              div.neutral400--text(v-else) Unavailable
                            td {{ payment.remarks }}
                y-button(label="Record payment" size="sm" @click="showRecordPaymentDialog = true")

        v-divider.mt-4.neutral400
        div
          v-data-table(:headers="headers" :items="stocks" hide-default-footer disable-sort loader-height="2" :items-per-page="-1")
            //- Number
            template(v-slot:item.number="{ item, index }")
              div {{ index + 1 }}
            //- Name
            template(v-slot:item.name="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                medication-stock-dropdown(v-if="item.editable" v-model="item.medicine")
                div(v-else-if="item.medicine") {{ item.medicine.name }}
            //- Quantity
            template(v-slot:item.quantity="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.quantity" placeholder="0" outlined dense height="48" type="number" :rules="rules.has_quantity" hide-details @input="calculateAmount(item, 'quantity')")
                div(v-else-if="item.quantity") {{ item.quantity }}
            //- Rate
            template(v-slot:item.rate="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.rate" placeholder="0.00" outlined dense height="48" type="number" :prefix="$currency.symbol" :rules="rules.has_price" hide-details @input="calculateAmount(item, 'rate')")
                div(v-else-if="item.rate") {{ $currency.symbol }} {{ item.rate }}
            //- UOM
            template(v-slot:item.uom="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                div(v-if="item.medicine && item.medicine.product && item.medicine.product.uom") {{ item.medicine.product.uom }}
            //- Expiry date
            template(v-slot:item.expiry_date="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                y-dialog(v-if="item.editable" v-model="item.showExpiredPicker" width='320px' persistent)
                  template(v-slot:activator='{ on }')
                    v-text-field.text-sm.round-xl.date-field(v-model="item.expiryDateField" placeholder="Expiry date" outlined dense height="48" readonly hide-details v-on="on" clearable)
                      template(v-slot:append)
                        eva-icon(name="calendar-outline" fill="#848484")
                  v-card
                    v-card-text.px-2.pt-2.pb-0
                      yc-date-picker(:parentDate.sync="item.selectedExpiryDate" color="info")
                    v-card-actions.px-4.pb-4
                      v-row(no-gutters)
                        v-col.pr-2
                          v-btn.button-sm(color="basic700" block dark outlined depressed @click="item.showExpiredPicker = false") {{ $t('cancel') }}
                        v-col.pl-2
                          v-btn.button-sm(color="info500" block depressed dark @click="pickItemDate(item)") {{ $t('select') }}
                div(v-else-if="item.expiryDateField") {{ item.expiryDateField }}
            //- Batch no
            template(v-slot:item.batch_no="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.batch_no" placeholder="Batch number" outlined dense height="48" hide-details)
                div(v-else-if="item.batch_no") {{ item.batch_no }}
            //- Total
            template(v-slot:item.total="{ item }")
              div.item-custom-style(@click.stop="clickRow(item)")
                v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.total" placeholder="100" outlined dense height="48" type="number" :prefix="$currency.symbol" :rules="rules.has_price" hide-details @input="calculateAmount(item, 'total')")
                div(v-else-if="item.total") {{ $currency.symbol }} {{ item.total }}
            //- Delete
            template(v-slot:item.action="{ item, index }")
              template(v-if="isCompletedItem(item)")
                v-btn(icon @click.stop="deleteItem(index)")
                  v-icon(size="18") $yzi-trash-03
            //- No data
            template(v-slot:no-data)
              div

        v-row.mt-8(no-gutters)
          v-col.pa-3(cols="3")
            div.text-sm.font-semibold.neutral700--text Remark
            v-textarea.text-sm.mt-2.round-xl(v-model="invoice.notes" placeholder="Enter your remark here" outlined rows="3" hide-details="auto")

          v-col.pa-3(cols="5")
            div.d-flex.align-center
              div.text-sm.font-semibold.neutral700--text Attachment
              v-spacer
              div.file-layout(v-if="!id && files.length")
                y-button(label="Add files" outlined size="xs" button-class="px-2" append-icon="$yzi-upload-01" icon-size="15")
                input.input-layout(type="file" @change="onFileChange" accept="image/*" style="width: 92px !important" multiple="multiple")
            div.d-flex.justify-center(v-if="isFetchingDocuments")
              v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
            template(v-else)
              template(v-if="files.length")
                v-card.round-xl.mt-2(outlined style="border-style: solid; border-color: var(--v-neutral400)")
                  v-simple-table
                    thead
                      tr
                        th.text-xs Name
                        th.text-xs(style="width: 120px;") Upload date
                        th.text-xs File type
                        th.text-xs(v-if="!id")
                    tbody
                      tr(v-for="(file, index) in files" :key="index")
                        td.text-sm.py-2(style="word-break: break-word;") {{ file.name }}
                        td.text-sm {{ file.date || getTodayDate() }}
                        td.text-sm {{ file.type }}
                        td.text-sm(v-if="!id")
                          v-btn(small icon @click="removeFile(index)")
                            v-icon(size="18") $yzi-trash-03
                div.d-flex.justify-end.mt-2
                  y-button(:label="getAttachmentButtonText()" underline size="xs" @click="showInvoiceAttachmentDialog = true")

              v-card.round-xl.pa-8.mt-2(v-else link outlined style="border-style: dashed; border-color: var(--v-neutral400)" @click="showInvoiceAttachmentDialog = true")
                .text-center
                  v-avatar.mb-3(color="neutral300" size="40")
                    v-icon(color="neutral500" size="18") $yzi-upload-01
                  .mb-1.text-sm 
                    span.font-semibold.info--text Click to upload 
                    | or drag and drop
                  .text-xs.neutral500--text PDF, DOCS, JPG, PNG (max. 4MB)
                //- input.input-change-layout(v-if="!id" ref="file" type="file" accept="image/png,image/jpeg,.pdf,.doc" multiple @change="onFileChange")

          v-col.pa-3(cols="3" offset="1" @click.stop)
            v-row(no-gutters)
              v-col.text-left.pl-4
                .text-sm.neutral700--text {{ $t('subtotal') }}
              v-col.text-right
                .text-sm.neutral700--text {{ (invoiceSubtotalAmount || 0) | displayPrice }}
            v-divider.neutral300.my-1

            v-row(no-gutters align="center")
              v-col.text-left.pl-4
                div.d-flex.align-center(style="height: 26px;")
                  template(v-if="invoice.adjustment_amount && invoice.adjustment_amount !== 0")
                    div.text-sm Adjustment
                    v-btn.ml-2(x-small icon @click="clearAmount('adjustment_amount')")
                      v-icon(small) mdi-close
                  template(v-else)
                    a.text-sm.font-semibold.underline.clickable(@click="showInputField('editAdjustment')") {{ $t('add_adjustment') }}
              v-col.text-right
                v-text-field.text-sm.round-xl(v-if="editAdjustment" v-model="invoice.adjustment_amount" placeholder="0.00" autofocus outlined dense height="48" type="number" :prefix="$currency.symbol" hide-details :loading="isLoadingInput" @blur="updateInput('editAdjustment', 'adjustment_amount')")
                .text-sm.neutral700--text(v-else) {{ (invoice.adjustment_amount || 0) | displayPrice }}
            v-divider.neutral300.my-1

            v-row(no-gutters align="center")
              v-col.text-left.pl-4
                div.d-flex.align-center(style="height: 26px;")
                  template(v-if="invoice.tax_amount && invoice.tax_amount !== 0")
                    div.text-sm tax
                    v-btn.ml-2(x-small icon @click="clearAmount('tax_amount')")
                      v-icon(small) mdi-close
                  template(v-else)
                    a.text-sm.font-semibold.underline.clickable(@click="showInputField('editTax')") Add tax
              v-col.text-right
                v-text-field.text-sm.round-xl(v-if="editTax" v-model="invoice.tax_amount" placeholder="0.00" autofocus outlined dense height="48" type="number" :prefix="$currency.symbol" hide-details :loading="isLoadingInput" @blur="updateInput('editTax', 'tax_amount')")
                .text-sm.neutral700--text(v-else) {{ (invoice.tax_amount || 0) | displayPrice }}
            v-divider.neutral300.my-1

            v-row(no-gutters align="center")
              v-col.text-left.pl-4
                div.d-flex.align-center(style="height: 26px;")
                  template(v-if="invoice.shipping_fee && invoice.shipping_fee !== 0")
                    div.text-sm Delivery charge
                    v-btn.ml-2(x-small icon @click="clearAmount('shipping_fee')")
                      v-icon(small) mdi-close
                  template(v-else)
                    a.text-sm.font-semibold.underline.clickable(@click="showInputField('editShippingFee')") Add delivery charge
              v-col.text-right
                v-text-field.text-sm.round-xl(v-if="editShippingFee" v-model="invoice.shipping_fee" placeholder="0.00" autofocus outlined dense height="48" type="number" :prefix="$currency.symbol" hide-details :loading="isLoadingInput" @blur="updateInput('editShippingFee', 'shipping_fee')")
                .text-sm.neutral700--text(v-else) {{ (invoice.shipping_fee || 0) | displayPrice }}
            v-divider.neutral300.my-1

            v-row(no-gutters align="center")
              v-col.text-left.pl-4
                div.d-flex.align-center(style="height: 26px;")
                  .text-sm.neutral700--text {{$t('total') }}
              v-col.text-right
                .text-sm.neutral700--text {{ invoiceTotalAmount | displayPrice }}
            v-divider.neutral300.my-1

            v-row(no-gutters align="center")
              v-col.text-left.pl-4
                div.d-flex.align-center(style="height: 26px;")
                  .text-sm.neutral700--text {{$t('paid') }}
              v-col.text-right
                .text-sm.neutral700--text {{ invoice.amount_paid | displayPrice }}
            v-divider.neutral300.my-1

            v-row(no-gutters align="center")
              v-col.text-left.pl-4
                div.d-flex.align-center(style="height: 26px;")
                  .text-lg.font-semibold.neutral700--text {{$t('amount_due') }}
              v-col.text-right
                .text-lg.font-semibold.neutral700--text {{ invoiceTotalRemaining | displayPrice }}

    v-footer.white(app inset padless elevation="3")
      v-container.px-10(fluid)
        div.d-flex.align-center
          v-spacer
          v-btn.button-md.underline.mr-4(text @click.stop="goBack") {{ $t('cancel') }}
          v-btn.button-md(color="neutral700" depressed :dark="!isFetching" :loading="isLoading" :disabled="isFetching" @click.stop="saveData") {{ $t('save') }}

    .dialogs
      invoice-attachment-dialog(v-if="showInvoiceAttachmentDialog" :open.sync="showInvoiceAttachmentDialog" :id="id" :invoice="invoice" @onUpdateCount="fetchDocuments")
      record-invoice-payment-dialog(v-if="showRecordPaymentDialog" :open.sync="showRecordPaymentDialog" :id="id" :invoice="invoice" @onUploaded="refetch()")
  </template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { isFileSizeOverLimit } from '@/utils'
import MedicationSoldByDropdown from '@/components/clinic/inventory/MedicationSoldByDropdown.vue'
import MedicationStockDropdown from '@/components/clinic/inventory/MedicationStockDropdown.vue'
import InvoiceAttachmentDialog from '@/components/clinic/inventory/invoice/InvoiceAttachmentDialog.vue'
import RecordInvoicePaymentDialog from '@/components/clinic/inventory/invoice/RecordInvoicePaymentDialog.vue'

export default {
  name: 'InventoryInvoice',
  components: { MedicationSoldByDropdown, MedicationStockDropdown, InvoiceAttachmentDialog, RecordInvoicePaymentDialog },
  props: ['id'],
  data() {
    return {
      isFetching: false,
      isFetchingDocuments: false,
      isLoading: false,
      isLoadingInput: false,
      showInvoicePicker: false,
      showPaymentDuePicker: false,
      showInvoiceAttachmentDialog: false,
      showRecordPaymentDialog: false,
      editAdjustment: false,
      editTax: false,
      editShippingFee: false,
      showSellerError: false,
      showSellerInput: false,
      showInvoiceNoInput: false,
      showInvoiceDateInput: false,
      showPaymentDueDateInput: false,
      showPaymentRecorded: false,
      invoiceDateField: null,
      PaymentDueDateField: null,
      filesCount: 0,
      seller: {},
      invoice: {},
      oriInvoice: {},
      files: [],
      payments: [],
      stocks: [{ editable: false, showExpiredPicker: false }],
      headers: [
        { text: '#', value: 'number', width: 40 },
        { text: 'Name', value: 'name'},
        { text: 'Qty', value: 'quantity', width: '8%' },
        { text: 'Rate', value: 'rate', width: '10%' },
        { text: 'UOM', value: 'uom', width: '10%' },
        { text: 'Exp date', value: 'expiry_date', width: '15%' },
        { text: 'Batch number', value: 'batch_no', width: '15%' },
        { text: 'Total Amount', value: 'total', width: '13%' },
        // { text: '', value: 'action', width: 72 },
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({ company: 'getCompany' }),
    invoiceSubtotalAmount () {
      let subtotal = 0
      this.stocks.forEach(stock => {
        if (stock.total) {
          subtotal += Math.round(Number(stock.total) * this.$currency.multiplier)
        }
      })
      if (this.id) {
        subtotal = this.invoice.amount
      }
      return subtotal
    },
    invoiceTotalAmount () {
      let total = 0
      if (!this.editAdjustment) { total += this.invoice.adjustment_amount || 0 }
      if (!this.editTax) { total += this.invoice.tax_amount || 0 }
      if (!this.editShippingFee) { total += this.invoice.shipping_fee || 0 }
      if (this.invoiceSubtotalAmount) {
        total += this.invoiceSubtotalAmount
      }
      if (this.id && !this.hasChanges) {
        total = this.invoice.amount_total
      }
      return total
    },
    invoiceTotalRemaining () {
      let remaining = this.invoiceTotalAmount
      if (this.invoice.amount_paid) {
        remaining -= this.invoice.amount_paid
      }
      if (this.id && !this.hasChanges) {
        remaining = this.invoice.amount_remaining
      }
      return remaining
    },
    hasChanges () {
      if (!this.invoice || !this.oriInvoice) {
        return false
      }
      let change = false
      if (this.invoice.adjustment_amount != this.oriInvoice.adjustment_amount) {
        change = true
      }
      if (this.invoice.tax_amount != this.oriInvoice.tax_amount) {
        change = true
      }
      if (this.invoice.shipping_fee != this.oriInvoice.shipping_fee) {
        change = true
      }
      return change
    }
  },
  mounted () {
    if (this.id) {
      this.fetchInvoice()
      this.fetchDocuments()
      this.fetchPayments()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchInvoice () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/inventory_invoices/${this.id}`)
        .then(resp => {
          let data = resp.data
          this.seller = { ...data.seller }
          this.stocks = data.items.map(item => {
            return {
              editable: false,
              showExpiredPicker: false,
              expiryDateField: item.product_inventory.expiry_date ? this.$options.filters.humanizeDate(item.product_inventory.expiry_date) : null,
              selectedExpiryDate: item.product_inventory.expiry_date,
              batch_no: item.product_inventory.batch_no,
              quantity: item.product_inventory.change,
              rate: ((item.product_inventory.cost / item.product_inventory.change) / this.$currency.multiplier).toFixed(2),
              total: (item.product_inventory.cost / this.$currency.multiplier).toFixed(2),
              medicine: {
                id: item.product_inventory.id,
                name: item.product_inventory.product.name,
                product: item.product_inventory.product
              }
            }
          })
          this.invoice = { ...data, record_date: data.record_date.substr(0, 10) }
          this.oriInvoice = JSON.parse(JSON.stringify(this.invoice))
          this.invoiceDateField = this.$options.filters.humanizeDate(data.record_date)
          this.PaymentDueDateField = data.due_at ? this.$options.filters.humanizeDate(data.due_at) : null
          this.isFetching = false
          // this.clickOutside()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    fetchDocuments () {
      this.isFetchingDocuments = true
      let params = { page_size: 2 }
      this.$axios.get(`/clinics/${this.company.slug}/inventory_invoices/${this.id}/documents/`, { params })
        .then(resp => {
          this.files = resp.data.results.map(file => {
            return {
              name: file.document.filename,
              date: this.$options.filters.humanizeDate(file.created),
              type: file.document.type,
              ...file
            }
          })
          this.filesCount = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingDocuments = false
        })
    },
    fetchPayments () {
      this.isFetchingDocuments = true
      let params = { page_size: -1 }
      this.$axios.get(`/clinics/${this.company.slug}/inventory_invoices/${this.id}/payments/`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.payments = resp.data.results
          }
        })
        .catch(() => {})
    },
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      if (isFileSizeOverLimit(files[0], 5)) {
        this.showMessage(['error', this.$t('error_message.file_reached_limit')])
        return
      }
      files.forEach(o => {
        this.files.push(o)
      })
    },
    async saveData () {
      this.closeEditable()
      this.closeEditableInvoice()
      if (!this.$refs.form.validate() || this.stocks.find(f => f.editable) || (Object.keys(this.seller).length == 0)) {
        if (Object.keys(this.seller).length == 0) {
          this.showSellerError = true
        }
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      let errorMessage = this.$t('error_message.unable_to_complete_request')
      try {
        if (this.id) {
          let payload = {
            record_date: this.invoice.record_date,
            due_at: this.invoice.due_at,
            seller: this.seller.sold_by,
            invoice_no: this.invoice.invoice_no,
            adjustment_amount: this.invoice.adjustment_amount,
            tax_amount: this.invoice.tax_amount,
            shipping_fee: this.invoice.shipping_fee,
            notes: this.invoice.notes,
          }
          await this.$axios.patch(`/clinics/${this.company.slug}/inventory_invoices/${this.id}`, payload)
        } else {
          let inventoryIds = []
          for (const stock of this.stocks) {
            if (!stock.medicine || !stock.quantity || !stock.rate) { continue }
            let data = {
              action: 'received',
              change: stock.quantity,
              cost: Math.round(Number(stock.total) * Number(this.$currency.multiplier))
            }
            if (stock.batch_no) { data.batch_no = stock.batch_no }
            if (stock.expiryDateField) { data.expiry_date = stock.selectedExpiryDate }
            errorMessage = 'Error updating stock'
            await this.$axios.post(`/products/${stock.medicine.product.id}/inventories`, data).then(resp => { inventoryIds.push(resp.data.id) })
          }
          if (inventoryIds.length) {
            let payload = { ...this.invoice }
            payload.product_inventory_ids = inventoryIds
            payload.seller = this.seller.sold_by
            let inventoryInvoiceId = null
            errorMessage = 'Error creating invoice'
            await this.$axios.post(`/clinics/${this.company.slug}/inventory_invoices/`, payload).then(resp2 => inventoryInvoiceId = resp2.data.id)
            if (this.files.length) {
              for (const file of this.files) {
                const formData = new FormData()
                formData.append('doc_type', 'invoice')
                formData.append('file', file)
                errorMessage = 'Error attach documents'
                await this.$axios.post(`/clinics/${this.company.slug}/inventory_invoices/${inventoryInvoiceId}/documents`, formData)
              }
            }
          }
        }
      } catch {
        this.showMessage(['error', errorMessage])
      } finally {
        this.isLoading = false
        this.goBack()
      }
    },
    pickDate (field, picker, date, showInput) {
      if (!date) { return }
      this[field] = this.$options.filters.humanizeDate(date)
      this[picker] = false
      this[showInput] = false
    },
    closePicker (picker, showInput, required) {
      if (!required) {
        this[showInput] = false
      }
      this[picker] = false
    },
    pickItemDate (item) {
      item.expiryDateField = this.$options.filters.humanizeDate(item.selectedExpiryDate)
      item.showExpiredPicker = false
    },
    clickRow (item) {
      console.log(item)
      return
      // this.closeEditable()
      // item.editable = true
    },
    clickOutside () {
      this.closeEditableInvoice()
      this.closeEditable()
      this.showPaymentRecorded = false
      // const notFullRow = this.stocks.find(f => !f.medicine || !f.quantity || !f.rate || !f.total)
      // const emptyRow = this.stocks.find(f => !f.medicine && !f.quantity && !f.rate && !f.total && !f.expiry_date && !f.batch_no)
      // if (!emptyRow && !notFullRow) {
      //   this.stocks.push({ editable: false, showExpiredPicker: false })
      // }
    },
    closeEditable () {
      return this.stocks.map(m => {
        if (m.medicine && m.quantity && m.rate && m.total) {
          m.editable = false
        } else if (!m.medicine && !m.quantity && !m.rate && !m.total && !m.expiry_date && !m.batch_no) {
          m.editable = false
        }
      })
    },
    closeEditableInvoice () {
      this.editAdjustment = false
      this.editTax = false
      this.editShippingFee = false
    },
    isCompletedItem (item) {
      if (!item.editable && item.medicine && item.quantity && item.rate && item.total) {
        return true
      }
      return false
    },
    showInputField (field) {
      this.closeEditableInvoice()
      this[field] = true
    },
    updateInput (field, amount) {
      if (!this.invoice[amount]) { return }
      let tempAmount = Math.round(this.invoice[amount] * this.$currency.multiplier)
      this.invoice[amount] = tempAmount
      if (this.id) {
        this.isLoadingInput = true
        const payload = { [amount]: tempAmount }
        this.$axios.patch(`/clinics/${this.company.slug}/inventory_invoices/${this.id}`, payload)
          .catch(() => {})
          .finally(() => {
            this.isLoadingInput = false
            this[field] = false
          })
      } else {
        this[field] = false
      }
    },
    deleteItem (idx) {
      this.stocks.splice(idx, 1)
    },
    removeFile (idx) {
      this.files.splice(idx, 1)
    },
    clearAmount (field) {
      if (this.id) {
        const payload = { [field]: 0 }
        this.$axios.patch(`/clinics/${this.company.slug}/inventory_invoices/${this.id}`, payload)
          .catch(() => {})
          .finally(() => {
            this.$set(this.invoice, field, 0)
          })
      } else {
        this.$set(this.invoice, field, 0)
      }
    },
    calculateAmount (item, type) {
      if (type === 'rate' && item.rate) {
        if (item.quantity) {
          item.total = (item.rate * item.quantity).toFixed(2)
        } else if (item.total) {
          item.total = null
        }
      } else if (type === 'total' && item.total) {
        if (item.quantity) {
          item.rate = (item.total / item.quantity).toFixed(2)
        } else if (item.rate) {
          item.rate = null
        }
      } else if (type === 'quantity' && item.quantity) {
        if (item.rate) {
          item.total = (item.rate * item.quantity).toFixed(2)
        } else if (item.total) {
          item.rate = (item.total / item.quantity).toFixed(2)
        }
      }
    },
    viewPaymentFile (item) {
      window.open(item.document.file)
    },
    getTodayDate () {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return this.$options.filters.humanizeDate(`${year}-${month}-${day}`)
    },
    getAttachmentButtonText () {
      let text = 'Edit of add more'
      if (this.filesCount > 2) {
        let count = this.filesCount - 2
        text = `+${count} more files. Show all`
      }
      return text
    },
    refetch () {
      this.fetchInvoice()
      this.fetchDocuments()
      this.fetchPayments()
    },
    goBack () {
      this.$router.push('/admin/clinic/inventory-invoices')
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-width {
  width: 50px !important;
}
.item-custom-style {
  display:grid;
  align-content: center;
  height: 60px;
  cursor: pointer;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
  cursor: pointer;
}
.v-tooltip__content {
  /* top: unset !important; */
  opacity: 1;
  border: black 1px solid !important;
  border-radius: 10px;
  padding: 8px;
  pointer-events: unset !important;
}
</style>